<template>
<div class="applyAdmitTab">
  <div class="sign-top">
        <div class="iconfont iconzuojiantou jian" @click="goBack"></div>
        <div>我的申请</div>
        <div></div>
  </div>
  <div style="height:100%">
    <van-tabs v-model="applysId.tab" @click="ontabChange" style="padding-bottom:45px">
      <van-tab title="申请中" name="1">
         <div class="noQianshu" v-if="applyList.length==0">
            <img :src="qianshu" alt="">
        </div>
        <div class="sing" v-for="(item, key) in applyList" :key="key" @click="onItemClick(item)">
          <div class="sing-left">
            <div class="sing-left-title">
              <span></span>
              <span class="title">{{item.platformDetailDTO.taskName}}</span>
            </div>
            <div class="sing-left-cont">
              <span>{{item.pTCityPlatformTaskDTO.areaName}}</span>
              <span class="line"></span>
              <span style="margin-left:5px">{{item.platformDetailDTO.requirementAgeMin}}--{{item.platformDetailDTO.requirementAgeMax}}</span>
            </div>
            <div class="sing-left-cont">
              <span v-if="item.platformDetailDTO.peopleNumber==-1">人数不限</span>
              <span v-else>{{item.platformDetailDTO.peopleNumber}}人</span>
              <span style="margin-left:5px" v-if="!item.platformDetailDTO.salaryUnit">面议</span>
              <span v-if="item.platformDetailDTO.salaryAsk == 'SECTION'">{{item.platformDetailDTO.salaryBlockMin}}-{{item.platformDetailDTO.salaryBlockMax}}/{{item.platformDetailDTO.salaryUnit}}
</span>
              <span v-if="item.platformDetailDTO.salaryAsk == 'FIXED'">{{item.platformDetailDTO.salarySettlement}}/{{item.platformDetailDTO.salaryUnit}}</span>
            </div>
          </div>
          <div class="sing-right" @click="checkContract">
            <div class="recall" v-if="item.applyStatus===0" @click="onRecall(item)">撤回</div>
          </div>
        </div>
      </van-tab>
     <van-tab title="已录取" name="3">
         <div class="noQianshu" v-if="applyList.length==0">
            <img :src="qianshu" alt="">
        </div>
        <div class="sing" v-for="(item, key) in applyList" :key="key" @click="onItemClick(item)">
          <div class="sing-left">
            <div class="sing-left-title">
              <span></span>
              <span class="title">{{item.platformDetailDTO.taskName}}</span>
            </div>
            <div class="sing-left-cont">
              <span>{{item.pTCityPlatformTaskDTO.areaName}}</span>
              <span class="line"></span>
              <span style="margin-left:5px">{{item.platformDetailDTO.requirementAgeMin}}--{{item.platformDetailDTO.requirementAgeMax}}</span>
              <span class="line"></span>
              <span style="margin-left:5px" v-if="item.signStatus == 1 || item.signStatus == 2">已签约</span>
              <span style="margin-left:5px" v-else-if="item.signStatus == 4">已过期</span>
              <span style="margin-left:5px" v-else-if="item.signStatus == 5">解约中</span>
              <span style="margin-left:5px" v-else-if="item.signStatus == 6">已解约</span>
              <span style="margin-left:5px" v-else>待签约</span>
            </div>
            <div class="sing-left-cont">
              <span v-if="item.platformDetailDTO.peopleNumber==-1">人数不限</span>
              <span v-else>{{item.platformDetailDTO.peopleNumber}}人</span>
              <span style="margin-left:5px" v-if="!item.platformDetailDTO.salaryUnit">面议</span>
              <span v-if="item.platformDetailDTO.salaryAsk == 'SECTION'">{{item.platformDetailDTO.salaryBlockMin}}-{{item.platformDetailDTO.salaryBlockMax}}/{{item.platformDetailDTO.salaryUnit}}
</span>
              <span v-if="item.platformDetailDTO.salaryAsk == 'FIXED'">{{item.platformDetailDTO.salarySettlement}}/{{item.platformDetailDTO.salaryUnit}}</span>
            </div>
          </div>
          <div class="sing-right" @click="checkContract">
            <div class="recall" v-if="item.applyStatus===0" @click="onRecall(item)">撤回</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <!-- 分页 -->
    <div class="footer" v-if="applyList.length!==0">
      <van-pagination v-model="applysId.currentPage" :total-items="pageCount" mode="simple" @change="ontabChange" />
    </div>
  </div>
</div>
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      applysId:{
        tab:1,
        currentPage:1,
        pageSize:10,
      },
      recallId:{
        id:""
      },
      pageCount:0,
      applyList:[],
      qianshu:require("../../../assets/img/qianshu.png"),
      // flag:"",
      payStr:""
    }
  } ,
  mounted(){
    const url = new URL(location.href);
    url.searchParams.get('tab') ?this.applysId.tab = url.searchParams.get('tab') :this.applysId.tab;
    url.searchParams.get('currentPage') ?this.applysId.currentPage = url.searchParams.get('currentPage') :this.applysId.currentPage;
    this.platformTaskApply();
  },
  methods:{
    platformTaskApply(){
      http.post(config.platformTaskApply,this.applysId).then(({code,data,message})=>{
        if(code===0){
          this.applyList=data.rows;
          this.pageCount=data.count;
        }else{
          this.$toast.fail(message)
        }
      })
    },
    onRecall(item){
      this.recallId.id=item.id;
      http.post(config.cancelApplication,this.recallId).then(({code,data,message})=>{
        if(code===0){
          this.$toast.success(message);
          this.platformTaskApply();
        }else{
          this.$toast.fail(message);
        }
      })

    },
    onItemClick(item) {
      this.$router.push({name: 'applyTabDetail', params: item,query:{tab:this.applysId.tab,currentPage:this.applysId.currentPage}})
    },

    goBack(){
      this.$router.push({name: 'updateInfo'});
    },
    ontabChange(){
      this.platformTaskApply()
    },
    checkContract(){
    }
  },
}
</script>
<style lang="less" scoped>
.applyAdmitTab{
  text-align: left;
  height: 100%;
  width: 100%;
  background: #f8f8f8;
  .noQianshu{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 60px;
    padding-top:150px;
    img{
      width: 50%;
      height: auto;
    }
  }
  .sing{
    display: flex;
    justify-content: space-between;
    align-items: center ;
    padding: 20px;
    background: #ffffff;
    margin-top: 10px;
    .sing-left{
      .sing-left-title{
        margin-bottom: 20px;
        .title{
          font-size: 30px;
        }

      }
      .sing-left-cont{
        font-size: 26px;
        color: #A4A4A4;
        position: relative;
        .line{
          width: 2px;
          height: 22px;
          position: absolute;
          top:8px;
          display: inline-block;
          background: #A4A4A4;
        }
      }
      .sing-left-time{
        font-size: 26px;
        color: #A4A4A4;
      }
    }
    .sing-right{
      .recall{
        width: 80px;
        height: 40px;
        border:1px solid #bbbbbb;
        text-align: center;
        line-height: 42px;
        border-radius: 4px;
      }
    }
  }
  .sign-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 35px;
    padding:20px;
    .jian{
    font-size: 35px;
  }

  }
  .footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #ffffff;
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/applyAdmit/applyAdmitTab/index.vue